import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useClinicMedicalSpecialty } from '../../hooks/useClinicMedicalSpecialty';

type Props = {
  children: React.ReactNode;
};

/** Redireciona rotas médicas não usadas em clínicas de fisioterapia. */
const FisioterapiaHiddenRoute: React.FC<Props> = ({ children }) => {
  const { isFisioterapia, loading } = useClinicMedicalSpecialty();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress size={32} />
      </Box>
    );
  }

  if (isFisioterapia) {
    return <Navigate to="/clinic/physiotherapy-assessments" replace />;
  }

  return <>{children}</>;
};

export default FisioterapiaHiddenRoute;
